/* tslint:disable */
/* eslint-disable */
/**
 * C4 Links Collab Catman API
 * API documentation for C4 Links Collab Catman
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Filter definition form type.
 */
export var FilterDefinitionFormType;
(function (FilterDefinitionFormType) {
  FilterDefinitionFormType['TEXT'] = 'TEXT';
  FilterDefinitionFormType['DATE'] = 'DATE';
  FilterDefinitionFormType['RADIO'] = 'RADIO';
  FilterDefinitionFormType['NUMBER'] = 'NUMBER';
  FilterDefinitionFormType['BOOLEAN'] = 'BOOLEAN';
  FilterDefinitionFormType['CHECKBOX'] = 'CHECKBOX';
  FilterDefinitionFormType['CHECKBOX_TREE'] = 'CHECKBOX_TREE';
  FilterDefinitionFormType['CHECKBOX_GRID'] = 'CHECKBOX_GRID';
  FilterDefinitionFormType['CHECKBOX_CARD'] = 'CHECKBOX_CARD';
  FilterDefinitionFormType['CHECKBOX_GROUP'] = 'CHECKBOX_GROUP';
  FilterDefinitionFormType['SELECT'] = 'SELECT';
  FilterDefinitionFormType['DATE_RANGE'] = 'DATE_RANGE';
  FilterDefinitionFormType['CUSTOM'] = 'CUSTOM';
})(FilterDefinitionFormType || (FilterDefinitionFormType = {}));
